// extracted by mini-css-extract-plugin
var _1 = "FormControls_between__2f59a";
var _2 = "FormControls_center__309b1";
var _3 = "FormControls_left__5d9e4";
var _4 = "FormControls_right__5a4f2";
var _5 = "FormControls_root__56e99";
export { _1 as "between", _2 as "center", _3 as "left", _4 as "right", _5 as "root" }
